import PublicAPI from "./api";

export const BannerApi = {
    get_banners: async () => {
        return await PublicAPI.get('/banners');
    }
};
